import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

interface IProps {
  label: string;
  color: string;
}

const StyledSpan: StyledFunction<{ color: string } & React.HTMLProps<HTMLInputElement>> = styled.span;
const Label = StyledSpan`
  position: relative;
  display: inline-block;
  margin-left: 8px;
  height: 20px;
  background-color: ${colors.lithium_light__e2e6ef};
  color: ${colors.metal_dark__626e8b};
  white-space: nowrap;
  font-weight: 700;
  font-size: 10px;
  line-height: 20px;
  min-width: 84px;
  text-align: center;
  border-radius: 0 2px 2px 0;

  &:before {
    position: absolute;
    top: 0;
    left: -8px;
    display: inline-block;
    width: 8px;
    height: 100%;
    border-radius: 2px 0 0 2px;
    content: '';
    background-color: ${props => props.color}
  }
`;

export class ProjectTypeLabel extends React.PureComponent<IProps, {}> {
  public render() {
    return <Label color={this.props.color}>{this.props.label}</Label>;
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/ProjectTypeLabel.tsx